import React, {createContext, ReactNode, useCallback, useContext, useEffect, useState} from 'react';
import {COMBINED_FOLDER_ID} from "../schemas/folder";
import {TagRead, TagType} from "../schemas";
import {useGroupContext} from "./group_context";


export interface FolderProviderContextType {
    /** Currently selected folder (now a TagRead with type=FOLDER_UPLOAD) */
    currentFolder?: TagRead | null;
    setCurrentFolder: (folder: TagRead | null | undefined) => void;
    /** All folder upload tags in the current group */
    groupFolders: TagRead[] | undefined;
    refreshGroupFolders: () => Promise<void>;
}

export const FolderProviderContext = createContext<FolderProviderContextType | undefined>(undefined);

interface FolderProviderProps {
    children: ReactNode;
}

export const FolderProvider: React.FC<FolderProviderProps> = ({
                                                                  children,
                                                              }) => {

    const {
        currentGroup,
        refreshCurrentGroup,
    } = useGroupContext()!;

    const [currentFolder, _setCurrentFolder] = useState<TagRead | null | undefined>(undefined);
    const [groupFolders, setGroupFolders] = useState<TagRead[] | undefined>(undefined);

    useEffect(() => {
        if (currentGroup) {
            console.log('FolderContext: currentGroup.tags =', currentGroup.tags);
            console.log('FolderContext: tag types =', currentGroup.tags.map(t => t.type));
            // Create a virtual "All Documents" folder
            const combinedFolder: TagRead = {
                id: COMBINED_FOLDER_ID,
                group_id: currentGroup.id,
                submitter_id: "",
                tag_name: "All Documents",
                type: TagType.FOLDER_UPLOAD,
                description: "A virtual folder containing all documents in the group.",
                document_count: currentGroup.document_count,
                created_at: "",
            }
            // Filter tags to only include FOLDER_UPLOAD type
            const folderUploadTags = currentGroup.tags.filter(
                tag => tag.type === TagType.FOLDER_UPLOAD
            );
            console.log('FolderContext: folderUploadTags =', folderUploadTags);
            setGroupFolders([combinedFolder, ...folderUploadTags]);
        }
    }, [currentGroup]); // Dependency array, re-run useEffect when currentGroup changes

    const setCurrentFolder = (folder: TagRead | null | undefined) => {
        if (folder != currentFolder) {
            _setCurrentFolder(folder);
        }
    }

    const refreshGroupFolders = useCallback(async () => {
        // Refresh the current group which will update the folders via the useEffect
        await refreshCurrentGroup();
    }, [refreshCurrentGroup]);

    const contextValue: FolderProviderContextType = {
        currentFolder,
        setCurrentFolder,
        groupFolders,
        refreshGroupFolders,
    };

    return (
        <FolderProviderContext.Provider value={contextValue}>
            {children}
        </FolderProviderContext.Provider>
    );
};

export const useFolderContext = () => useContext(FolderProviderContext);
